module.exports = __webpack_public_path__ + "img/transaction succeeded.6936afbb.svg";